const billingFrequencyLabelMap = {
    MONTHLY: 'cart.subscription.billingFrequency.monthly',
    QUARTERLY: 'cart.subscription.billingFrequency.quarterly'
};
const deliveryFrequencyLabelMap = {
    MONTHLY: 'cart.subscription.deliveryFrequency.monthly',
    QUARTERLY: 'cart.subscription.deliveryFrequency.quarterly'
};
const getSubscriptionFrequencyLabel = (enumValue, type)=>{
    switch(type){
        case 'billingFrequency':
            return billingFrequencyLabelMap[enumValue];
        case 'deliveryFrequency':
            return deliveryFrequencyLabelMap[enumValue];
    }
};

export { billingFrequencyLabelMap, deliveryFrequencyLabelMap, getSubscriptionFrequencyLabel };
//# sourceMappingURL=get-subscription-frequency-labels.js.map
